// removed by extract-text-webpack-plugin
module.exports = {"container":"AccessDenied__container___3O6Dd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccessDenied/AccessDenied.css
// module id = 985
// module chunks = 0